import React, { useState, useEffect } from 'react';
import { Dropdown, Checkbox, Button, Badge, Typography, Flex } from '@duxton-web/ui';
import { ChevronDownUniversal } from '@duxton-web/icons';
import {
  colorOutlineDefault,
  colorContentSubtle,
  colorBrandPrimaryBoldest,
  colorContentPlaceholder,
} from '@duxton-web/design-tokens/themes/light';
import './MultiSelectDropdown.scss';

interface Option {
  label: string;
  value: string;
}

interface Props {
  className?: string;
  onChange: (values: string[]) => void;
  placeholder: string;
  initialValue?: string[];
  options: Option[];
  width?: string; // this is the trigger button width
  menuWidth?: string;
  height?: string;
  multiValuePlaceholder?: string;
  buttonStyle?: React.CSSProperties;
  placeholderStyle?: React.CSSProperties;
}

const MultiSelectDropdown: React.FC<Props> = (props) => {
  const [chosen, setChosen] = useState<string[]>(
    props.initialValue ? props.initialValue : [],
  );
  const [isDropDownVisible, setIsDropDownVisible] = useState<boolean>(false);

  useEffect(() => {
    setChosen(props.initialValue ? props.initialValue : []);
  }, [props.initialValue]);
  const getLabelFromValue = (value: string): string => {
    for (const option of props.options) {
      if (option.value === value) {
        return option.label;
      }
    }
    return '';
  };
  const getPlaceHolder = (): string => {
    if (chosen.length > 1) {
      return props.multiValuePlaceholder
        ? props.multiValuePlaceholder
        : props.placeholder;
    } else if (chosen.length === 1) {
      return getLabelFromValue(chosen[0]);
    }
    return props.placeholder;
  };

  const handleSelect = (checkedValues: string[]) => {
    props.onChange(checkedValues);
    setChosen(checkedValues);
  };

  const handleOpenChange = (open: boolean, info: { source?: string }) => {
    setIsDropDownVisible(info.source !== 'menu' ? open : true);
  };

  return (
    <div className="multiSelectDropdown">
      <Checkbox.Group
        value={chosen}
        onChange={handleSelect}
        style={{ width: props.width, height: props.height }}
      >
        <Dropdown
          open={isDropDownVisible}
          onOpenChange={handleOpenChange}
          menu={{
            items: props.options.map((menuItem) => ({
              key: menuItem.value,
              value: menuItem.value,
              label: (
                <Checkbox
                  style={{ width: '100%' }}
                  value={menuItem.value}
                  key={menuItem.value}
                >
                  {menuItem.label}
                </Checkbox>
              ),
            })),
          }}
        >
          <Button
            style={{
              height: props.height,
              borderColor: colorOutlineDefault,
              color: colorContentSubtle,
              fontWeight: 400,
              width: props.width,
              ...props.buttonStyle,
            }}
          >
            <Flex
              vertical={false}
              style={{ width: '100%' }}
              align="center"
              justify="space-between"
              gap={2}
            >

              <Typography.Body
                level={3}
                style={{
                  color:
                    chosen.length > 0
                      ? colorBrandPrimaryBoldest
                      : colorContentPlaceholder,
                  ...props.placeholderStyle,

                }}
              >
                {getPlaceHolder()}
              </Typography.Body>

              <Flex vertical={false} align="center">
                <ChevronDownUniversal />
                {chosen.length > 1 && (
                  <Badge count={chosen.length} color="green" type="nested" />
                )}
              </Flex>
            </Flex>
          </Button>
        </Dropdown>
      </Checkbox.Group>
    </div>
  );
};

export default MultiSelectDropdown;
